import { render, staticRenderFns } from "./AuditLogText.vue?vue&type=template&id=5f1f06a2&scoped=true&"
import script from "./AuditLogText.vue?vue&type=script&lang=js&"
export * from "./AuditLogText.vue?vue&type=script&lang=js&"
import style0 from "./AuditLogText.vue?vue&type=style&index=0&id=5f1f06a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1f06a2",
  null
  
)

export default component.exports